export const terms = {
  "TERM-ALL-RIGHTS": "Todos los derechos reservados.",
  "TERM-SIDEBAR-ABOUT-US": "¿Quiénes somos?",
  "TERM-SIDEBAR-WORKSHOPS-COURSES": "Talleres y cursos",
  "TERM-SIDEBAR-JOB": "Empleo",
  "TERM-SIDEBAR-BUDGET": "Presupuesto",
  "TERM-SIDEBAR-DIGITAL-BILLBOARD": "Cartelera digital",
  "TERM-SIDEBAR-ALLIANCES": "Alianzas",
  "TERM-NOT-FOUND-TEXT": "Lo sentimos, el recurso que buscabas no existe.",
  "TERM-NOT-FOUND-BUTTON": "Volver a Cacao en Bytes",
  "TERM-SEE-MORE-SERVICES": "Ver más información",
  "TERM-OUR-SERVICES": "Nuestros servicios",
  "TERM-CLIENT-SERVICES": "Servicios",
  "TERM-SIDEBAR-HOME": "Inicio",
  "TERM-CLIENT-VACANCIES": "Vacantes de empleo",
  "TERM-CLIENT-VACANCIES-DESCRIPTION": "Requisitos",
  "TERM-CLIENT-VACANCIES-OFFER": "Oferta",
  "TERM-CLIENT-POST-DOWNLOAD": "Descargar",
  "TERM-CLIENT-POSTS": "Cartelera digital",
  "TERM-SIDEBAR-CONTACT-US": "Contáctanos",
  "TERM-CLIENT-CONTACT-TITLE-PANAMA": "CACAO Technology Solutions S.A (Panamá)",
  "TERM-CLIENT-CONTACT-PANAMA-ADDRESS":
    "Dirección comercial: World Trade Center, Piso 1 Área Ejecutiva, Marbella, calle 53, Panamá, Ciudad de Panamá.",
  "TERM-CLIENT-CONTACT-PHONE": "Teléfono",
  "TERM-CLIENT-CONTACT-VENEZUELA-ADDRESS":
    "Dirección comercial: Centro Comercial Lido, Av. Francisco de Miranda,Torre D, Piso 4, Local 41 D, Caracas, Venezuela 1060.",
  "TERM-CLIENT-CONTACT-TITLE-VENEZUELA":
    "CACAO Servicios Tecnológicos C.A (Vzla)",
  "TERM-CLIENT-CONTACT-EMAIL": "Contactanos a través de nuestro Email",
  "TERM-CLIENT-POST-LINK": "Ver enlace",
  "TERM-CLIENT-ABOUT-US-1P":
    "La empresa fue creada en el año 2010 con el propósito de atender la demanda de servicios, consultorías y cursos existente en Latinoamérica con respecto al área de bases de datos Oracle, sistemas operativos Solaris – Linux y programación.",
  "TERM-CLIENT-ABOUT-US-2P":
    "Los miembros de la directiva de CacaoenBytes, laboraron para Sun Microsystems (empresa adquirida por Oracle), y una vez culminado su periodo laboral en esta organización, decidieron aliarse y crear una propia, para ofrecer su experiencia en negocios vinculados con el sector de Tecnología e Información.",
  "TERM-CLIENT-ABOUT-US-3P":
    "Desde entonces, la empresa se ha posicionado como especialista en estos sistemas, apalancando en ellos, su oferta de servicios y dividiéndola en 3 grandes rubros: Servicios profesionales de TI, Integración de soluciones para el monitoreo de los componentes de red informática y su desempeño y Capacitación en Solaris, Oracle, Java y Linux.",
  "TERM-CLIENT-ABOUT-US-4P":
    "Hoy día, Cacao es reconocida por proveer recursos humanos altamente capacitados y con certificaciones internacionales en éstas áreas. Sus consultores son solicitados por este diferencial, y a través de sus actuales socios de negocio (Oracle, Nagios Enterprise), además de brindar sus servicios en Panamá y Venezuela, extiende su operación a toda la región de Centro América y Latinoamérica.",
  "TERM-CLIENT-ABOUT-US-MISSION": "Misión",
  "TERM-CLIENT-ABOUT-US-VISION": "Visión",
  "TERM-CLIENT-ABOUT-US-MISSION-TEXT":
    "Proveer Servicios Profesionales de alta calidad dirigidos a la construcción y optimización del departamento de sistemas de nuestros clientes, así como tambien, ofrecer cursos y asesorías acerca de los componentes, estándares y mejores practicas de la gestión tecnológica.",
  "TERM-CLIENT-ABOUT-US-VISION-TEXT":
    "Ser reconocidos por manejar una relación ética, profesional y de gran dedicación con nuestros clientes, proveyéndoles la mejor solución tecnológica para su empresa.",
  "TERM-CLIENT-ALLIES-TITLE-NAGIOS": "Reseller Nagios en Panamá",
  "TERM-CLIENT-ALLIES-TEXT-NAGIOS":
    "Nagios® es el líder en soluciones de monitoreo de infraestructura de Tecnología de Información (TI), y atiende las necesidades de miles de organizaciones en todo el mundo. Por su parte, CACAO Servicios Tecnológicos cuenta la experiencia de exitosos casos de implementación e integración de esta poderosa herramienta. Con esta alianza de negocios, se potencia la relación y la oferta de servicios, garantizando a nuestros clientes un mayor respaldo y la más dedicada atención.",
  "TERM-CLIENT-ALLIES-TITLE-ORACLE": "Proveedor de Oracle",
  "TERM-CLIENT-ALLIES-TEXT-ORACLE":
    "Somos proveedores para Oracle en el área de Servicios Profesionales en LatinoAmérica. Adicionalmenti, proveemos también instructores de Solaris para sus partners en la región.",
  "TERM-CLIENT-BUDGET-SELECT-LABEL": "Seleccione uno o más productos",
  "TERM-CLIENT-BUDGET-REQUIRED-EQ": "Equipos requeridos",
  "TERM-CLIENT-BUDGET-PERSO": "personalizada",
  "TERM-CLIENT-BUDGET-C/U": "Costo unitario",
  "TERM-CLIENT-BUDGET-CT": "Costo total",
  "TERM-CLIENT-BUDGET-QRN": "Indique la cantidad de nodos requeridos",
  "TERM-CLIENT-BUDGET-DR": "Duración requerida",
  "TERM-CLIENT-BUDGET-NOTE": "Nota",
  "TERM-CLIENT-BUDGET-NOTE-TEXT":
    "los valores ingresados sirven para indicar la licencia correspondiente según el caso y la disponibilidad actual.",
  "TERM-CLIENT-BUDGET-LICENSE":
    "Licencia disponible para los parámetros indicados:",
  "TERM-CLIENT-BUDGET-LICENSE-COST": "Costo:",
  "TERM-CLIENT-BUDGET-LICENSE-QE": "Cantidad de equipos:",
  "TERM-CLIENT-BUDGET-LICENSE-TERM": "Duración:",
  "TERM-CLIENT-BUDGET-TERM-YEAR": "Año",
  "TERM-CLIENT-BUDGET-TERM-YEARS": "Años",
  "TERM-CLIENT-BUDGET-PRODUCT":
    "El costo de este producto se calcula tomando en cuenta la cantidad de nodos o equipos requeridos y el costo unitario del producto.",
  "TERM-CLIENT-BUDGET-TERM-LABEL": "Duración (Años)",
  "TERM-CLIENT-BUDGET-BTN": "Generar presupuesto",
  "TERM-CLIENT-BUDGET-EMAIL-TEXT":
    "Por favor, introduzca su correo electrónico para enviar el presupuesto estimado con todos los detalles.",
  "TERM-CLIENT-BUDGET-ERROR":
    "Error al enviar el presupuesto, por favor intente nuevamente.",
  "TERM-CLIENT-BUDGET-SUCCESS-1": "Presupuesto enviado a",
  "TERM-CLIENT-BUDGET-SUCCESS-2": "satisfactoriamente",
  "TERM-CLIENT-BUDGET-INFO":
    "Por favor seleccione uno o más productos para generar el presupuesto.",
  "TERM-CLIENT-BUDGET-HOME-TEXT":
    "Construye tu paquete de productos con nuestra calculadora y genera tu presupuesto estimado ahora.",
  "TERM-CLIENT-BUDGET-HOME-BTN": "Visitar Calculadora",
  "TERM-CLIENT-BUDGET-HOME-CLIENTS": "Clientes",
  "TERM-CLIENT-COURSES-TEXT":
    "CACAO pensando en la satisfaccion de sus clientes, pone a su disposición talleres y cursos especializados y personalizados, a través de los cuales, adquirirá de manera rápida y efectiva el conocimiento requerido para atender las actividades de su empresa que así lo demanden. Nuestros talleres tienen una duración de 4 y hasta 32 horas, los cursos pueden ir desde 24 horas hasta 40 horas y son 100% adaptables a sus requerimientos y necesidades. Pueden ser dictados en las salas CACAO o In Situ. Los horarios pueden ser diurnos, nocturnos y sabatinos.",
  "TERM-CLIENT-COURSES-BDP": "Base de datos y Programación",
  "TERM-CLIENT-COURSES-BDP-TEXT":
    "Aprenda los fundamentos de una de las bases de datos más usadas a nivel global.",
  "TERM-CLIENT-COURSES-FMSQL": "Fundamento de MySQL",
  "TERM-CLIENT-COURSES-AMSQL": "Administracion de MySQL",
  "TERM-CLIENT-COURSES-AMSQL-TEXT":
    "Conozca más del poderoso manejador de base de datos usado por grandes coporaciones en todo el mundo.",
  "TERM-CLIENT-COURSES-LINUX": "Linux",
  "TERM-CLIENT-COURSES-LINUX-FGLU": "Fundamentos de GNU-Linux/Unix",
  "TERM-CLIENT-COURSES-LINUX-FGLU-TEXT":
    "Curso introductorio al mundo GNU-Linux/Unix. Conozca más sobre el sistema operativo que ayuda a ahorrar miles de dolares a las empresas.",
  "TERM-CLIENT-COURSES-LINUX-AGLU": "Administración de GNU-Linux",
  "TERM-CLIENT-COURSES-LINUX-AAGLU": "Administración Avanzada GNU-Linux",
  "TERM-CLIENT-COURSES-LINUX-AAGLU-TEXT":
    "Usted aprenderá a instalar y configurar sobre GNU-Linux/Unix,servicios tales como mirrors, multiphatings, ldap client, nfs, etc.",
  "TERM-CLIENT-COURSES-LINUX-SS": "ShellScript",
  "TERM-CLIENT-COURSES-LINUX-SS-TEXT":
    "Curso que provee a Administradores de Sistemas Operativos (Sysadmins), conocimientos de como lograr automatización de procesos. Bash, Bourne, Korn son los shells principalmente usados en el curso.",
  "TERM-CLIENT-BUDGET-EMAIL-RULE": "Ingresar un correo electrónico válido",
  "TERM-CLIENT-BUDGET-NOTEMPTY-RULE": "El campo no puede estar vacío",
  "TERM-CLIENT-BUDGET-LOADING": "Enviando presupuesto...",
  "TERM-CLIENT-NOT-FOUND-PAGINATION":
    "El número de página actual no existe. Por favor, usa el menú de navegación o la paginación propuesta por la aplicación.",
  "TERM-CLIENT-VZLA-PHONE": "+58 212-9056303",
  "TERM-CLIENT-PANAMA-PHONE": "+507-67713727"
};
